const AI_DEFAULT_REALM = 'HERE';

export const getAiAuthorizationClaims = () => {
  const userId = process.env.REACT_APP_AI_USER_ID || 'test-user';
  const realm = process.env.REACT_APP_AI_REALM || AI_DEFAULT_REALM;

  return btoa(JSON.stringify({ sub: userId, rlm: realm }));
};
